import { IAppState } from '@state/types';
import * as types from './types';

export const getDealers = (state: IAppState): types.IDealerState => state.dealers;
